module.exports = __webpack_public_path__ + "img/commandeReception.c07415b5.png";